<template>
    <div class="stats-cards-area">
        <div class="container-fluid">
            <div class="row">
                <!-- Total de Notícias -->
                <div class="col-xl-3 col-md-6">
                    <div class="stat-card stat-card--blue">
                        <div class="stat-card__icon">
                            <i class="ri-newspaper-line"></i>
                        </div>
                        <div class="stat-card__body">
                            <span class="stat-card__label">Notícias</span>
                            <h3 class="stat-card__value">
                                <span v-if="loading" class="stat-skeleton"></span>
                                <span v-else>{{ counts.news }}</span>
                            </h3>
                            <p class="stat-card__sub">Total publicadas</p>
                        </div>
                    </div>
                </div>

                <!-- Total de Eventos -->
                <div class="col-xl-3 col-md-6">
                    <div class="stat-card stat-card--green">
                        <div class="stat-card__icon">
                            <i class="ri-calendar-event-line"></i>
                        </div>
                        <div class="stat-card__body">
                            <span class="stat-card__label">Eventos</span>
                            <h3 class="stat-card__value">
                                <span v-if="loading" class="stat-skeleton"></span>
                                <span v-else>{{ counts.events }}</span>
                            </h3>
                            <p class="stat-card__sub">Total registados</p>
                        </div>
                    </div>
                </div>

                <!-- Total de Projetos -->
                <div class="col-xl-3 col-md-6">
                    <div class="stat-card stat-card--purple">
                        <div class="stat-card__icon">
                            <i class="ri-folder-chart-line"></i>
                        </div>
                        <div class="stat-card__body">
                            <span class="stat-card__label">Projetos</span>
                            <h3 class="stat-card__value">
                                <span v-if="loading" class="stat-skeleton"></span>
                                <span v-else>{{ counts.projects }}</span>
                            </h3>
                            <p class="stat-card__sub">Total ativos</p>
                        </div>
                    </div>
                </div>

                <!-- Total de Doações -->
                <div class="col-xl-3 col-md-6">
                    <div class="stat-card stat-card--orange">
                        <div class="stat-card__icon">
                            <i class="ri-hand-heart-line"></i>
                        </div>
                        <div class="stat-card__body">
                            <span class="stat-card__label">Doações</span>
                            <h3 class="stat-card__value">
                                <span v-if="loading" class="stat-skeleton"></span>
                                <span v-else>{{ counts.donations }}</span>
                            </h3>
                            <p class="stat-card__sub">Total recebidas</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StatsCards',
    props: {
        counts: {
            type: Object,
            default: () => ({ news: 0, events: 0, projects: 0, donations: 0 }),
        },
        loading: {
            type: Boolean,
            default: true,
        },
    },
};
</script>

<style lang="scss">
.stats-cards-area {
    padding-bottom: 0;
    margin-bottom: 24px;
}

.stat-card {
    background: #fff;
    border-radius: 20px;
    border: 1px solid #DFE9FF;
    padding: 28px 24px;
    display: flex;
    align-items: center;
    gap: 18px;
    margin-bottom: 24px;
    box-shadow: 0 2px 15px rgba(0,0,0,.03);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    &:hover {
        transform: translateY(-3px);
        box-shadow: 0 8px 25px rgba(0,0,0,.08);
    }

    &__icon {
        width: 60px;
        height: 60px;
        border-radius: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        font-size: 26px;
    }
    &__label {
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 0.8px;
        text-transform: uppercase;
        display: block;
        margin-bottom: 4px;
    }
    &__value {
        font-size: 32px;
        font-weight: 700;
        margin: 0 0 4px;
        letter-spacing: -1px;
        min-height: 38px;
    }
    &__sub {
        font-size: 12px;
        color: #9ca3af;
        margin: 0;
    }

    &--blue {
        .stat-card__icon { background: #EBF1FF; color: #1765FD; }
        .stat-card__label { color: #1765FD; }
    }
    &--green {
        .stat-card__icon { background: #EDFBF3; color: #4FCB8D; }
        .stat-card__label { color: #4FCB8D; }
    }
    &--purple {
        .stat-card__icon { background: #F0EBFF; color: #5C31D6; }
        .stat-card__label { color: #5C31D6; }
    }
    &--orange {
        .stat-card__icon { background: #FFF3EB; color: #FF6B35; }
        .stat-card__label { color: #FF6B35; }
    }
}

.stat-skeleton {
    display: inline-block;
    width: 60px;
    height: 32px;
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: shimmer 1.2s infinite;
    border-radius: 8px;
}
@keyframes shimmer {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
}

@media (max-width: 767px) {
    .stat-card { padding: 20px 16px; }
    .stat-card__value { font-size: 26px; }
}
</style>
